import { render, staticRenderFns } from "./hud.svg.vue?vue&type=template&id=70160daa&"
import script from "./hud.svg.vue?vue&type=script&lang=js&"
export * from "./hud.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports